module.exports = __webpack_public_path__ + "static/media/icon_logout.abab519c.svg";